import MuiAlert, { AlertProps } from "@mui/material/Alert";

export const ErrorAlert = (props: AlertProps) => {
    return <MuiAlert severity="error" elevation={6} variant="filled" {...props} />;
};
